import { render } from "./PostCarpoolStep6.view.vue?vue&type=template&id=54fc33c4"
import script from "./PostCarpoolStep6.view.vue?vue&type=script&lang=js"
export * from "./PostCarpoolStep6.view.vue?vue&type=script&lang=js"

import "./PostCarpoolStep6.view.vue?vue&type=style&index=0&id=54fc33c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__